import { useCallback } from 'react';

import {
  boardSwitcherOpenSharedState,
  boardSwitcherSearchSharedState,
  useBoardSwitcherMode,
} from '@trello/board-switcher';
import { useOpenBoardPanel } from '@trello/split-screen';

export const useOpenBoardAndHideSwitcher = () => {
  const openBoardPanel = useOpenBoardPanel();

  const mode = useBoardSwitcherMode();

  return useCallback(() => {
    openBoardPanel();

    boardSwitcherSearchSharedState.setValue({
      query: null,
    });

    if (mode === 'modal') {
      boardSwitcherOpenSharedState.setValue({ isOpen: false });
    }
  }, [mode, openBoardPanel]);
};
